import {SupportSettingWidgetModel} from '~/site/model/models/supportSettingWidgetModel'
import {MissionCenterSettingModel} from '~/site/model/models/MissionCenterSettingModel'

export const SiteEnum = {
  BASE_PAGE: 'home',
  BASE_PAGE_ID: 0
}

export const NavTypeEnum = {
  URL: '1',
  PAGE: '2',
  MODEL: '3',
  PAGE_PATH: '4'
}

export const SiteColumnsNameEnum = {
  PAGE: '页面',
  LOGIN: '登陆',
  SEO: 'SEO',
  THEME: '主题',
  ASSETS: '素材库',
  LANGUAGE: '语言',
  SETTING: '配置',
  GLOBAL: '全局'
}

export const PageSetting = {
  getMenuInfo() {
    return {
      icon: 'icon-buju',
      name: SiteColumnsNameEnum.PAGE
    }
  }
}

export const LoginSetting = {
  children: [
    //
  ],
  getMenuInfo() {
    return {
      icon: 'icon-yonghu',
      name: SiteColumnsNameEnum.LOGIN
    }
  }
}

export const GlobalSetting = {
  children: [
    {
      name: SiteColumnsNameEnum.ASSETS
    },
    {
      name: SiteColumnsNameEnum.GLOBAL
    },
    {
      name: SiteColumnsNameEnum.LANGUAGE
    },
    {
      name: SiteColumnsNameEnum.SEO
    }
  ],
  getMenuInfo() {
    return {
      icon: 'icon-apps',
      name: SiteColumnsNameEnum.GLOBAL
    }
  }
}

export const ColumnsSetting = [
  PageSetting,
  LoginSetting,
  GlobalSetting
]

export const InterCurrency = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'IDR', 'TWD']

export const RechargeAnyValueId = "9999"

export const EventCodeEnums = {
  STORE_VISITED: 'STORE_VISITED',
  EMAIL_LOGIN_SHOW: 'EMAIL_LOGIN_SHOW',
  EMAIL_BIND_UID: 'EMAIL_BIND_UID',
  UID_LOGIN_SHOW: 'UID_LOGIN_SHOW',
  UID_LOGIN: 'UID_LOGIN',
  PAYMENT_SHOW: 'PAYMENT_SHOW',
  EMAIL_LOGIN: 'EMAIL_LOGIN',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_CHOOSE: 'PAYMENT_CHOOSE',
  PAYMENT_SUBMIT: 'PAYMENT_SUBMIT',
  PAYMENT_MIDDLE_SHOW: 'PAYMENT_MIDDLE_SHOW',
  ORDER_SHOW: 'ORDER_SHOW',
  PWA_INSTALL: 'PWA_INSTALL',
  MODULE_CLICK: 'MODULE_CLICK'
}

export const ModuleNameEnum = {
  CustomerService: '客服',
  MissionCenter: '任务中心',
  DialogCollection: '弹窗集',
  Consecutive: '充值签到',
  Carousel: '轮播图',
  Collapse: '折叠内容',
  QuenUnlock: '顺序解锁购买',
  StandaloneProduct: '独立商品',
  Header: '页头',
  Footer: '页脚',
  VipUserInfo: '用户信息'
}

export const ModuleTitleEnum = {
  DialogCollection: 'dialogCollection',
  DialogItem: 'dialogItem',
  ProjectVipUserInfo: 'projectVipUserInfo',
  ProjectVipLevelUp: 'projectVipLevelUp',
  ProjectVipRights: 'projectVipRights'
}

export const DialogShowTypeValueEnums = {
  immediate: 1,
  uidEveryday: 2,
  deviceEveryDay: 3,
  uidOnce: 4
}

export const DialogShowTypeEnums = [
  {
    label: '开屏即显示',
    value: DialogShowTypeValueEnums.immediate
  },
  {
    label: 'UID每天一次',
    value: DialogShowTypeValueEnums.uidEveryday
  },
  {
    label: '设备每天一次',
    value: DialogShowTypeValueEnums.deviceEveryDay
  },
  {
    label: '[UID+设备]终身一次',
    value: DialogShowTypeValueEnums.uidOnce
  }
]

export const SpeModuleModelNames = [
  SupportSettingWidgetModel.name,
  MissionCenterSettingModel.name
]


export const WidgetModelNames = {
  ActivityWidgetModel: 'ActivityWidgetModel',
  SignActivityWidgetModel: 'SignActivityWidgetModel',
  ConvertKeyWidgetModel: 'ConvertKeyWidgetModel',
  ConvertKeyWidgetV2Model: 'ConvertKeyWidgetV2Model',
  ConsecutiveWidgetModel: 'ConsecutiveWidgetModel',
  LotteryWidgetModel: 'LotteryWidgetModel',
  MonthCardWidgetModel: 'MonthCardWidgetModel',
  DialogCollectionWidgetModel: 'DialogCollectionWidgetModel',
  MissionCenterSettingModel: 'MissionCenterSettingModel',
  SupportSettingWidgetModel: 'SupportSettingWidgetModel',
  DialogItemWidgetModel: 'DialogItemWidgetModel',
  FooterQuickLinkWidgetModel: 'FooterQuickLinkWidgetModel',
  FooterTextWidgetModel: 'FooterTextWidgetModel',
  FooterMediaWidgetModel: 'FooterMediaWidgetModel',
  FooterWidgetModel: 'FooterWidgetModel',
  RechargeWidgetV3Model: 'RechargeWidgetV3Model',
  HeaderWidgetModel: 'HeaderWidgetModel',
  CarouselWidgetModel: 'CarouselWidgetModel',
  ImageTextWidgetModel: 'ImageTextWidgetModel',
  ImageTextItemWidgetModel: 'ImageTextItemWidgetModel',
  CollapseWidgetModel: 'CollapseWidgetModel',
  QuenUnlockWidgetModel: 'QuenUnlockWidgetModel',
  StandaloneProductWidgetModel: 'StandaloneProductWidgetModel',
  PwaSettingWidgetModel: 'PwaSettingWidgetModel',
  PwaWidgetModel: 'PwaWidgetModel',
  InviteCodeWidgetModel: 'InviteCodeWidgetModel',
  TextWidgetModel: 'TextWidgetModel',
  StoreWidgetV2Model: 'StoreWidgetV2Model',
  ProjectVipUserInfoWidgetModel: 'ProjectVipUserInfoWidgetModel',
  ProjectVipLevelUpWidgetModel: 'ProjectVipLevelUpWidgetModel',
  ProjectVipRightsWidgetModel: 'ProjectVipRightsWidgetModel',
  CyclePackageWidgetModel: 'CyclePackageWidgetModel',
  MenuManageWidgetModel: 'MenuManageWidgetModel'
}

export const WidgetModuleMenuNames = {
  [WidgetModelNames.StoreWidgetV2Model]: '分类商品',
  [WidgetModelNames.MonthCardWidgetModel]: '月卡',
  [WidgetModelNames.ActivityWidgetModel]: '累充',
  [WidgetModelNames.ConsecutiveWidgetModel]: '充值签到',
  [WidgetModelNames.SignActivityWidgetModel]: '签到',
  [WidgetModelNames.LotteryWidgetModel]: '抽奖',
  [WidgetModelNames.InviteCodeWidgetModel]: '邀请码',
  [WidgetModelNames.ConvertKeyWidgetModel]: '兑换码',
  [WidgetModelNames.QuenUnlockWidgetModel]: '顺序解锁购买',
  [WidgetModelNames.CarouselWidgetModel]: '轮播图',
  [WidgetModelNames.CollapseWidgetModel]: '折叠内容',
  [WidgetModelNames.ImageTextWidgetModel]: '图文',
  [WidgetModelNames.TextWidgetModel]: '文本',
  [WidgetModelNames.ProjectVipUserInfoWidgetModel]: '会员用户信息',
  [WidgetModelNames.ProjectVipLevelUpWidgetModel]: '会员升级奖励',
  [WidgetModelNames.ProjectVipRightsWidgetModel]: '会员权益',
  [WidgetModelNames.CyclePackageWidgetModel]: '周期礼包',
  [WidgetModelNames.MenuManageWidgetModel]: '菜单管理'
}

export const SettingModelNames = {
  LoginSettingModel: 'LoginSettingModel',
  GlobalSettingModel: 'GlobalSettingModel',
  LangSettingModel: 'LangSettingModel',
  ModuleNavigationWidgetModel: 'ModuleNavigationWidgetModel',
  PwaWidgetModel: 'PwaWidgetModel',
  [WidgetModelNames.MissionCenterSettingModel]: WidgetModelNames.MissionCenterSettingModel,
  [WidgetModelNames.SupportSettingWidgetModel]: WidgetModelNames.SupportSettingWidgetModel,
  NoticeWidgetModel: 'NoticeWidgetModel'
}

export const GlobalModulesNames = [SettingModelNames.LoginSettingModel, SettingModelNames.LangSettingModel, SettingModelNames.PwaWidgetModel, SettingModelNames.NoticeWidgetModel, WidgetModelNames.MissionCenterSettingModel, SettingModelNames.SupportSettingWidgetModel]

export const SpeModuleModelNamesMap = {
  [SupportSettingWidgetModel.name]: ModuleNameEnum.CustomerService,
  [MissionCenterSettingModel.name]: ModuleNameEnum.MissionCenter
}

export const GlobalWidgetModules = [ModuleNameEnum.CustomerService, ModuleNameEnum.MissionCenter]

export const EditorWrapperClass = '.edit-content__center--wrapper'

export const ImageSizeListEnums = [
  {
    label: '充满',
    value: 'object-fill'
  },
  {
    label: '适应',
    value: 'object-contain'
  }
]
